var cacheUtils = {}
cacheUtils.cache = function(key, value) {
    if (value === undefined)
        return JSON.parse(localStorage.getItem(key))
    localStorage.setItem(key, JSON.stringify(value));
}
export default cacheUtils


// WEBPACK FOOTER //
// ./src/utils/cacheUtils.js